import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import Vuetify, {
  VApp,
  VLayout,
  VFlex,
  VAvatar,
  VForm,
  VBtn,
  VIcon,
  VCheckbox,
  VTextField,
  VSelect,
  VTab,
  VTabs,
  VTabsSlider,
  VMenu,
  VList,
  VListItem,
  VDialog,
  VCard,
  VTextarea,
  VSnackbar,
  VTooltip
} from 'vuetify/lib';
import Notifications from 'vue-notification';
import 'intersection-observer';
import i18n from '@/i18n';
import App from './App';
import router from './router';
import store from './store';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';
import '@/assets/scss/app.scss';
import '@/filters';

Sentry.init({
  beforeSend(event) {
    if (process.env.VUE_APP_ENV === 'local') return null;
    return event;
  },
  environment: process.env.VUE_APP_ENV,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [new Integrations.Vue({ Vue, attachProps: true, logErrors: true })]
});

Sentry.configureScope(scope => {
  scope.setExtra('width', window.innerWidth);
  scope.setExtra('height', window.innerHeight);
  scope.setExtra('browserLocale', window.navigator ? (window.navigator.language || window.navigator.systemLanguage || window.navigator.userLanguage) : 'en');
});

Vue.config.productionTip = false;

Vue.use(Vuetify, {
  components: {
    VApp,
    VLayout,
    VFlex,
    VAvatar,
    VForm,
    VBtn,
    VIcon,
    VCheckbox,
    VTextField,
    VSelect,
    VTab,
    VTabs,
    VTabsSlider,
    VMenu,
    VList,
    VListItem,
    VDialog,
    VCard,
    VTextarea,
    VSnackbar,
    VTooltip
  }
});

Vue.use(Notifications);

Vue.prototype.$eventHub = new Vue();

new Vue({
  i18n,
  router,
  store,
  vuetify: new Vuetify({ icons: { iconfont: 'mdi' } }),
  render: h => h(App)
}).$mount('#app');
